// extracted by mini-css-extract-plugin
export var card = "Slide-module--card--7ca56";
export var interactive = "Slide-module--interactive--97527";
export var img = "Slide-module--img--7fbcd";